import { getLocale } from './detectLocale';
import { first } from 'lodash';

const currentLocales = getLocale();
export const currentLanguage = localStorage.getItem('appLang') || first(currentLocales);

window.LANGUAGE_MAP = {};

export const loadTranslationsForApp = async app => {
  if (currentLanguage === 'pl') {
    return Promise.resolve();
  }

  if (process.env.NODE_ENV !== 'development') {
    // TODO: change url
    const response = await fetch(`/translations/${app}/${currentLanguage}.json`);
    window.LANGUAGE_MAP = await response.json();
  }
  return Promise.resolve();
};

const getTransValue = key => window.LANGUAGE_MAP[key] || key;

const getReplaceValue = (key, obj) => {
  let keyVal = getTransValue(key);
  Object.entries(obj).forEach(([k, v]) => {
    keyVal = keyVal.replace(`%${k}%`, v);
  });
  return keyVal;
};

export const translate = (...args) => {
  let key = args[0];
  if (args.length === 2) {
    return getReplaceValue(args[0], args[1]);
  } else if (args.length === 3 && args[2] > 1) {
    key = args[1];
  } else if (args.length === 4) {
    if (args[2] > 1) {
      key = args[1];
    }
    return getReplaceValue(key, args[3]);
  }
  return getTransValue(key);
};
export const trans = translate;
